import React from 'react';
import reform from 'components/Reform';
import Fieldset from 'components/Fieldset';
import Button from 'components/Button';

const AccountDetails = ({ password, email, formValid, handleChange, handleFocus, onSubmit }) => (
  <form
    onSubmit={onSubmit}
    className="viewcontainer stepDetails signup"
    name="signupAccountDetails"
  >
    <Fieldset
      field={email}
      name="email"
      inputType="email"
      labelText="Email"
      autoComplete="email"
      onChange={handleChange}
      onFocus={handleFocus}
      testId="signup-email"
      hideAsterisk
    />
    <Fieldset
      field={password}
      name="password"
      inputType="password"
      labelText="Password"
      autoComplete="new-password"
      onChange={handleChange}
      onFocus={handleFocus}
      testId="signup-password"
      hideAsterisk
    />
    <div className="fieldset fieldset--rightflex">
      <Button
        disabled={!formValid}
        title={formValid ? 'Proceed to step 2 of 3' : 'Please complete the form'}
        buttonText="Next step"
        type="submit"
        data-test-id="signup-button-accountDetails"
        className="button--fullWidth"
      />
    </div>
  </form>
);
export default reform()(AccountDetails);
